module.exports = __webpack_public_path__ + "11902454e95f0c597f0c5ae98a7c82f2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/retro-gaming-system-s.png
// module id = 2722
// module chunks = 0